export default __webpack_public_path__ + "static/media/onboarding.6acb7f6e.svg";